module.exports = __webpack_public_path__ + "img/color_control.377c0e9e.svg";